import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64e787da"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "ai-message"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "message-dialog-triangle" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "inner-triangle" })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = { class: "observation" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AiFinding = _resolveComponent("AiFinding")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_observation_controller = _resolveComponent("observation-controller")!

  return (!_ctx.isHidden)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["insight", { active: _ctx.isActive }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setActive(_ctx.insight))),
        onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setActive(_ctx.insight))),
        tabindex: "0"
      }, [
        _createElementVNode("div", {
          class: "title",
          ref: _ctx.insight.key
        }, [
          (_ctx.insight.icon)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "title-legend-icon",
                style: _normalizeStyle(_ctx.getLegendIcon)
              }, null, 4))
            : _createCommentVNode("", true),
          _createElementVNode("span", null, _toDisplayString(_ctx.t(`config.insight.slide.${_ctx.activeCase.tissue}.${_ctx.activeSlide.stain}.${_ctx.insight.key}.title`)), 1)
        ], 512),
        (_ctx.isAnalysisPerformed)
          ? (_openBlock(), _createBlock(_component_AiFinding, {
              key: 0,
              onCopyAIFindings: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copyAIFindings())),
              insight: _ctx.insight
            }, null, 8, ["insight"]))
          : _createCommentVNode("", true),
        (_ctx.insight.message)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _hoisted_2,
              _createVNode(_component_i18n_t, {
                tag: "span",
                keypath: _ctx.insightMessage
              }, {
                newline: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["keypath"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_observation_controller, {
            onObservationChange: _ctx.handleChange,
            insight: _ctx.insight,
            prefill: _ctx.computedPrefill,
            disabled: _ctx.isSlideReportComplete,
            isActive: _ctx.isActive
          }, null, 8, ["onObservationChange", "insight", "prefill", "disabled", "isActive"])
        ])
      ], 34))
    : _createCommentVNode("", true)
}